import React from 'react';
import styles from './Button.module.sass';
import gaTags from '../../../utils/ga-tags'

const NOT_SPECIFIED = 'Não Especificada'

const button = (props) => {

    const allClasses = [props.className, styles.button, gaTags.class];
    if (props.selected) {
        allClasses.push(styles.selected);
    }
    return <button {...props}
              className={allClasses.join(' ')}
              onClick={event => {
                window.dataLayer.push({
                  'event': 'datalayereventos',
                  'gacategory': event.target.getAttribute('data-gacategory') || NOT_SPECIFIED,
                  'gatype': event.target.getAttribute('data-gatype') || NOT_SPECIFIED,
                  'gafunc': event.target.getAttribute('data-gafunc') || NOT_SPECIFIED
                });
                if (props.hasOwnProperty("onClick")){
                  props.onClick(event)
                }
              }}>
                {props.children}
            </button>
};

export default button;
